export default __webpack_public_path__ + "static/media/96237-success.4de79479.gif";